import { OnboardingModal } from './onboarding-modal';

export { OnboardingModal };
